<template>
	<div class="rightInner">
		<div class="searchArea">
			<div class="title">
				<div class="titleLine"></div>
					{{$t('mypages.invoices.title')}}
			</div>
			<div>
				<div class="conditions">
						<div class="condition">
							<div class="conditionLabel">{{$t('mypages.invoices.label_invoice_no')}}</div>
							<input type="text" class="small" :placeholder="$t('mypages.invoices.placeholder_invoice_no')" v-model="form.invoiceNo" />
						</div>
						<div class="condition">
							<div class="conditionLabel">{{$t('mypages.invoices.label_platform_order_no')}}</div>
							<input type="text" class="small" :placeholder="$t('mypages.invoices.placeholder_platform_order_no')" v-model="form.orderNo" />
						</div>
						<div class="condition">
							<div class="conditionLabel">{{$t('mypages.invoices.label_purchase_order_no')}}</div>
							<input type="text" class="small" :placeholder="$t('mypages.invoices.placeholder_purchase_order_no')" v-model="form.saleNo" />
						</div>
				</div>
				<div class="conditions setPadding">
						<div class="condition">
							<div class="conditionLabel">{{$t('mypages.invoices.label_invoice_time')}}</div>
						<div class="calendarArea">
							<div class="calendarInner" @click="strarShow()">
								<input type="text"   v-model="form.startTime"/>
								<img src="../../assets/images/dateIcon.png" />
							</div>
							<div class="calendatPopup" v-if="isStart">
								<CalendarVue @changeDate="getDate" :initDay="calendarInitDay"></CalendarVue>
							</div>
						</div>
						<div class="calendarLine">-</div>
						<div class="calendarArea">
							<div class="calendarInner" @click="endShow()">
								<input type="text" v-model="form.endTime" />
								<img src="../../assets/images/dateIcon.png" />
							</div>
							<div class="calendatPopup" v-if="isEnd">
								<CalendarVue @changeDate="getDate" :initDay="calendarInitDay"></CalendarVue>
							</div>
						</div>
						<div class="searchBtn btnStyle" @click="Search()">{{$t('mypages.invoices.search')}}</div>
						<div class="resetBen btnStyle" @click="Reset()">{{$t('mypages.invoices.reset')}}</div>
					</div>
				</div>
			</div>

		</div>
		
		<table>
			<thead>
						<th>
							<div class="tdInner">{{$t('mypages.invoices.th_invoice_no')}}</div>
						</th>
						<th>
							<div class="tdInner">{{$t('mypages.invoices.th_invoice_time')}}</div>
						</th>
						<th>
							<div class="tdInner">{{$t('mypages.invoices.th_invoice_amount')}}</div>
						</th>
						<th>
							<div class="tdInner">{{$t('mypages.invoices.th_platform_order_no')}}</div>
						</th>
						<th>
							<div class="tdInner">{{$t('mypages.invoices.th_purchase_order_no')}}</div>
						</th>
						<th>
							<div class="tdInner">{{$t('mypages.invoices.th_action')}}</div>
						</th>
			</thead>
			<tbody>
				<tr v-for="(item, index) in invoiceList" :key="item.id">
					<td>
						<div class="tdInner">{{item.invoice_no}}</div>
					</td>
					<td>
						<div class="tdInner">{{item.gmt_invoice}}</div>
					</td>
					<td>
						<div class="tdInner redText">￥{{item.invoice_money}}</div>
					</td>
					<td>
						<div class="tdInner">{{item.order_no}}</div>
					</td>
					<td>
						<div class="tdInner">{{item.sale_no}}</div>
					</td>
					<td>
						<div class="tdInner">
								<div class="btn">{{$t('mypages.invoices.btn_download')}}</div>
						</div>
					</td>
				</tr>
				
			</tbody>
		</table>
		<div class="paginationArea">
						<PaginationVue  :TotalCount="totalcount" :pageSize="10" @pageChenged="handlePage"></PaginationVue>
					</div>
	</div>
</template>

<script>
	import CalendarVue from "../../components/calendar.vue"
	import PaginationVue from '../../components/pagination.vue';
	export default{
		components:{
			CalendarVue,
			PaginationVue
		},
		data(){
			return {
				calendarInitDay: '2024-12-1',
				isStart: false,
				isEnd:false,
				allItems:['1','2','3','4','5','6','7','8','9','10','11','12','13','14'],
				invoiceList:[],
				totalcount:1,
				pageIndex:1,
				form: {
					orderNo: '',
					invoiceNo: '',
					saleNo:'',
					startTime: '',
					endTime: '',
					status:''
				},
			}
		},
		created(){
			this.getInvoiceListInfo();
		},
		mounted(){
			 document.addEventListener('click', this.hideCalendar)
		},		
		methods:{			
			handlePage(message) {
				console.log(message);
				this.pageIndex = message;
				this.getOrderListInfo();
			},
			getDate(d){
				console.log(d)
				if(this.isStart){
					this.isStart = !this.isStart;
					this.form.startTime=d;
					return;
				}
				if(this.isEnd){
					this.isEnd = !this.isEnd;
					this.form.endTime=d;
					return;
				}
			},
			strarShow(){
				this.isStart = true;
				this.isEnd = false;
			},
			endShow(){
				this.isEnd = true;
				this.isStart = false
			},
			hideCalendar(event){
			    if (!event.target.closest('.calendarArea')) {
					this.isStart = false;
					this.isEnd = false;
				}
			},
			detailClick(){
				this.$emit('detailClick')
			},
			getInvoiceListInfo() {
				this.invoiceList=[];
				this.$scUtil.axiosPut(this, 'InvoiceApi/GetInvoicePageList', {
					orderNo: this.form.orderNo,
					saleNo:this.form.saleNo,
					invoiceNo:this.form.invoiceNo,
					startTime:this.form.startTime,
					endTime:this.form.endTime,
					userName: localStorage.getItem('username'),
					pageIndex:this.pageIndex,
					pageSize:10,
					status:1
				}, res => {
					console.log(res.code);
					if (res.code == 100) {
						this.invoiceList = res.data;
						this.totalcount=res.totalcount;
						console.log(JSON.stringify(this.invoiceList))

					}

				});
			},
			Search()
			{
					this.getInvoiceListInfo();
			},
			Reset(){
				this.form.orderNo='';
				this.form.invoiceNo='';
				this.form.saleNo='',
				this.form.startTime='',
				this.form.endTime='',
				this.getInvoiceListInfo();
			}
		}
	}
</script>

<style scoped>
	.rightInner{
		width: 958px
	}
	.searchArea{
		width: 100%;	
		background-color: #fff;
	}
	.title{
		font-size: 14px;
		color: #000000;
		display:flex;
		align-items: center;
		height: 52px;
		border-bottom: 1px solid #e2e2e2;
		padding-left: 20px;
	}
	
	.titleLine{
		width: 4px;
		height: 14px;
		background-color: #0380fe;
		margin-right: 15px;
	}
	.conditions,.condition{
		display: flex;
		align-items: center;
	}
	
	.conditions{
		margin-top: 20px;
		padding-left: 20px;
	}
	
	.conditionLabel{
		font-size: 13px;
		color: #000000;
		margin-right: 10px;
		width: 80px;
		text-align: right;
	}
	
	.small{
		width: 158px;
		height: 32px;
	}
	
	.condition input{
		border: 1px solid #e2e2e2;
		font-size: 13px;
		color: #000;
		padding-left: 10px;
	}
	
	.condition input:focus{
		outline: none;
	}
	
	.condition input::placeholder{
		color: #888;
	}
	
	.condition{
		margin-right: 40px;
	}
	
	.condition:nth-last-child(1){
		margin-right: 0px;
	}
	
	.calendarArea{
		position: relative;
		display: flex;
		align-items: center;
	}	
	
	.calendarArea input{
		height: 170px;
		height: 32px;
		border: none;
	}
	
	.calendarInner{
		width: 200px;
		height: 32px;
		border: 1px solid #e2e2e2;
	}
	
	.calendatPopup{
		position: absolute;
		width: 260px;
		top: 34px;
		left: 0;
		background-color: #fff;
		box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.1),
		0 1px 5px 0 rgba(0, 0, 0, 0.12);
	}
	
	.calendarLine{
		margin: 0 15px;
	}
	
	.setPadding{
		padding-bottom: 20px;
		border-bottom: 1px solid #e2e2e2;
	}
	
	.searchBtn{		
		color: #ffffff;
		background-color: #0380fe;
		border: 1px solid #0380fe;	
		margin-left: 36px;
	}
	
	.resetBen{
		color: #ffffff;
		border: 1px solid #e2e2e2;
		color: #666666;
		margin-left: 17px;
	}
	
	.btnStyle{
		width:105px;
		height: 32px;
		font-size: 13px;
		border-radius: 5px;
		text-align: center;
		line-height: 32px;
		cursor: pointer;
	}
	
	table{
		background-color: #fff;
		margin-top: 12px;
		width: 100%;
		border-collapse: collapse;
	}

	table thead th{
		height: 58px;
		font-size: 13px;
		color: #333333;
		border-bottom: 1px solid #e2e2e2;
	}
	
	table tbody tr td {
		border-bottom: 1px solid #e2e2e2;
	}
	
	table tbody tr td .tdInner{
		min-height:63px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 13px;
		color: #000000;
	}
	
	table tbody tr td .redText{
		color: #db050f;
		font-size: 13px;
		font-weight: bolder;
	}
	
	.btn{
		width: 77px;
		height: 25px;
		color: #0380fe;
		font-size: 12px;
		border: 1px solid #0380fe;
		text-align: center;
		line-height: 25px;
		cursor: pointer;
	}
	
	.paginationArea{
		display: flex;
		justify-content: center;
		background-color: #fff;
		padding: 17px 0;
	}
	
</style>